import { Box, Chip, Typography } from "@mui/material";

type CrewFilterOption = {
  label: string;
  value: string;
};

type CrewFilterChipsProps = {
  label: string;
  options: CrewFilterOption[];
  value: string;
  onChange: (value: string) => void;
};

export const CrewFilterChips = ({
  label,
  options,
  value,
  onChange,
}: CrewFilterChipsProps) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
    <Typography className="dashboard-metric-label">{label}:</Typography>
    {options.map((option) => (
      <Chip
        key={option.value}
        label={option.label}
        size="small"
        clickable
        color={option.value === value ? "primary" : "default"}
        onClick={() => onChange(option.value)}
        sx={{ borderRadius: "8px", fontWeight: 500 }}
      />
    ))}
  </Box>
);
